import { Card } from "@/components/ui/card";
import { Network, ChevronRight } from "lucide-react";
import { ActionCard as ActionCardType } from "@/types";

interface ActionCardProps {
  card: ActionCardType;
  onClick: (card: ActionCardType) => void;
  isActive?: boolean;
}

const ActionCard = ({ card, onClick, isActive = false }: ActionCardProps) => {
  const handleClick = () => {
    onClick(card);
  };

  const getIcon = () => {
    switch (card.type) {
      case "meeting-summary":
        return <Network className="h-5 w-5" />;
      default:
        return <Network className="h-5 w-5" />;
    }
  };

  return (
    <Card
      className={`p-4 hover:shadow-md cursor-pointer ${
        isActive
          ? "border-2 border-blue-500 bg-blue-50"
          : "border border-gray-200"
      }`}
      onClick={handleClick}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0">{getIcon()}</div>
          <div>
            <h4 className="font-medium text-sm">{card.title}</h4>
            {card.subtitle && (
              <p className="text-xs text-gray-500 mt-0.5">{card.subtitle}</p>
            )}
          </div>
        </div>
        <ChevronRight className="h-4 w-4 text-gray-400" />
      </div>
    </Card>
  );
};

export default ActionCard;
